/**
 * Shared Canvas Engine Constants
 *
 * Common constants for canvas-based rendering engines.
 * Used by both DataTableEngine and SubsurfaceScene.
 */

// ============================================================================
// Render Loop Timing
// ============================================================================

/** Maximum renderer pixel ratio to avoid excessive memory usage on high-DPI displays */
export const MAX_RENDERER_PIXEL_RATIO = 2;

/** Milliseconds between idle renders (effectively 1 fps when nothing is happening) */
export const IDLE_FRAME_INTERVAL_MS = 1000;

/** Milliseconds to stay in "active" rendering mode after a user interaction */
export const INTERACTION_ACTIVE_WINDOW_MS = 300;

/** Milliseconds to stay in "active" rendering mode after an extension requests render */
export const EXTENSION_ACTIVE_WINDOW_MS = 500;

/** Maximum active window duration to prevent runaway rendering */
export const MAX_ACTIVE_WINDOW_MS = 2_000;

// ============================================================================
// Frame Budget
// ============================================================================

/** Frame time budget in milliseconds (target 60fps) */
export const FRAME_BUDGET_MS = 1000 / 60;

/** Default interval for "low" tier extensions when no minFrameIntervalMs specified */
export const DEFAULT_LOW_TIER_INTERVAL_MS = 100; // 10fps for low-priority extensions

/** Multiplier applied to intervals when frame budget is exceeded */
export const LOAD_THROTTLE_MULTIPLIER = 2;

// ============================================================================
// Typography
// ============================================================================

/**
 * Canonical canvas font family. The graph's `FONT_FAMILY` and the
 * DataTable's `DEFAULT_FONT_FAMILY` both re-export this so existing
 * constants using them keep working.
 */
export const CANVAS_FONT_FAMILY = "Inter, system-ui, sans-serif";
